import { ListItemText } from '@material-ui/core';
import React from 'react';
import translations from './translations';

export const getUISchema = (intl, code, { countries }) => {
  switch (code) {
    case 'exact':
      return {
        configuration: {
          country_code: {
            component: 'CountrySelect',
            props: {
              label: intl.formatMessage(translations.properties.countryCode),
              options: countries,
              valueOnly: true,
            },
          },
        },
        credentials: {},
      };
    case 'ftp':
      return {
        configuration: {
          host: {
            props: {
              label: intl.formatMessage(translations.properties.host),
            },
          },
          is_passive: {
            props: {
              label: intl.formatMessage(translations.properties.isPassive),
            },
          },
          is_secure: {
            props: {
              label: intl.formatMessage(translations.properties.isSecure),
            },
          },
          port: {
            props: {
              label: intl.formatMessage(translations.properties.port),
            },
          },
          root: {
            props: {
              label: intl.formatMessage(translations.properties.root),
            },
          },
        },
        credentials: {
          username: {
            props: {
              label: intl.formatMessage(translations.properties.username),
            },
          },
          password: {
            props: {
              label: intl.formatMessage(translations.properties.password),
              type: 'password',
            },
          },
        },
      };
    case 'recaptcha':
      return {
        configuration: {
          key: {
            props: {
              label: intl.formatMessage(translations.properties.recaptchaSiteKey),
            },
          },
        },
        credentials: {
          secret: {
            props: {
              label: intl.formatMessage(translations.properties.recaptchaSecret),
            },
          },
        },
      };
    case 'cmpayments':
      return {
        configuration: {
          key: {
            props: {
              label: intl.formatMessage(translations.properties.oauthClientKey),
            },
          },
        },
        credentials: {
          secret: {
            props: {
              label: intl.formatMessage(translations.properties.secret),
              type: 'password',
            },
          },
        },
      };
    case 'paynl':
      return {
        configuration: {
          service_id: {
            props: {
              label: intl.formatMessage(translations.properties.serviceId),
            },
          },
          token_code: {
            props: {
              label: intl.formatMessage(translations.properties.tokenCode),
            },
          },
        },
        credentials: {
          apiToken: {
            props: {
              label: intl.formatMessage(translations.properties.apiToken),
            },
          },
        },
      };
    case 'sendcloud':
      return {
        configuration: {
          key: {
            props: {
              label: intl.formatMessage(translations.properties.apiKey),
            },
          },
        },
        credentials: {
          secret: {
            props: {
              label: intl.formatMessage(translations.properties.secret),
            },
          },
        },
      };
    case 'slack':
      return {
        configuration: {
          channel: {
            props: {
              label: intl.formatMessage(translations.properties.slackChannel),
            },
          },
          username: {
            props: {
              label: intl.formatMessage(translations.properties.username),
            },
          },
        },
        credentials: {
          webhook_url: {
            props: {
              label: intl.formatMessage(translations.properties.webhookUrl),
            },
          },
        },
      };
    case 'shopctrl':
      return {
        configuration: {
          url: {
            props: {
              label: intl.formatMessage(translations.properties.shopctrlUrl),
            },
          },
          username: {
            props: {
              label: intl.formatMessage(translations.properties.username),
            },
          },
        },
        credentials: {
          password: {
            props: {
              label: intl.formatMessage(translations.properties.password),
              type: 'password',
            },
          },
        },
      };
    case 'dpd':
      return {
        configuration: {
          delis_id: {
            props: {
              label: intl.formatMessage(translations.properties.delisId),
            },
          },
        },
        credentials: {
          password: {
            props: {
              label: intl.formatMessage(translations.properties.password),
              type: 'password',
            },
          },
        },
      };
    case 'bol':
      return {
        configuration: {
          id: {
            props: {
              label: intl.formatMessage(translations.properties.clientId),
            },
          },
          channel_id: {
            component: 'AsyncAutocomplete',
            props: {
              label: intl.formatMessage(translations.properties.channel),
              url: '/cat/channels',
              valueOnly: true,
              disableClearable: true,
              formatOptions: options =>
                options.map(option => ({ ...option, label: option.name, value: option.id })),
              requestOptions: {
                params: {
                  type: 'order',
                },
                headers: {
                  'x-page-size': 250,
                },
              },
            },
          },
          shipment_method_id: {
            component: 'ShippingMethodSearch',
            props: {
              label: intl.formatMessage(translations.properties.defaultShippingMethod),
              valueOnly: true,
              disableClearable: true,
              requestOptions: {
                params: {},
                headers: {
                  'x-page-size': 250,
                },
              },
            },
          },
          shipping_methods: {
            props: {
              label: intl.formatMessage(translations.properties.shippingMethods),
            },
            afosto_method_id: {
              component: 'ShippingMethodSearch',
              props: {
                label: intl.formatMessage(translations.properties.shippingMethod),
                valueOnly: true,
                requestOptions: {
                  params: {},
                  headers: {
                    'x-page-size': 250,
                  },
                },
              },
            },
            bol_transporter_code: {
              props: {
                label: intl.formatMessage(translations.properties.bolShippingMethod),
              },
            },
          },
        },
        credentials: {
          secret: {
            props: {
              label: intl.formatMessage(translations.properties.secret),
            },
          },
        },
      };
    case 'afosto':
      return {
        configuration: {
          channels: {
            props: {
              label: intl.formatMessage(translations.properties.channel),
            },
            channel_id: {
              component: 'AsyncAutocomplete',
              props: {
                label: intl.formatMessage(translations.properties.channel),
                url: '/cat/channels',
                valueOnly: true,
                disableClearable: true,
                // eslint-disable-next-line react/prop-types
                renderOption: ({ name, type }) => <ListItemText primary={name} secondary={type} />,
                formatOptions: options =>
                  options.map(option => ({
                    ...option,
                    label: option.name,
                    value: option.id,
                  })),
                requestOptions: {
                  headers: {
                    'x-page-size': 250,
                  },
                },
              },
            },
            external_service_id: {
              props: {
                label: intl.formatMessage(translations.properties.externalServiceId),
              },
            },
            address_id: {
              props: {
                label: intl.formatMessage(translations.properties.defaultShippingAddress),
              },
            },
          },
          shipment_method_id: {
            component: 'ShippingMethodSearch',
            props: {
              label: intl.formatMessage(translations.properties.defaultShippingMethod),
              valueOnly: true,
              requestOptions: {
                params: {},
                headers: {
                  'x-page-size': 250,
                },
              },
            },
          },
          shipping_methods: {
            props: {
              label: intl.formatMessage(translations.properties.shippingMethods),
            },
            af_shipping_method_id: {
              props: {
                label: intl.formatMessage(translations.properties.afostoCmsShippingMethod),
              },
            },
            spid: {
              component: 'AsyncAutocomplete',
              props: {
                label: intl.formatMessage(translations.properties.spid),
                url: '/lcs/locations',
                helperText: intl.formatMessage(translations.properties.spidHelperText),
                valueOnly: true,
                disableClearable: true,
                // eslint-disable-next-line react/prop-types
                renderOption: ({ name, type }) => <ListItemText primary={name} secondary={type} />,
                formatOptions: options =>
                  options.map(option => ({
                    ...option,
                    label: option.name,
                    value: option.id,
                  })),
                requestOptions: {
                  headers: {
                    'x-page-size': 250,
                  },
                },
              },
            },
            shipping_method_id: {
              component: 'ShippingMethodSearch',
              props: {
                label: intl.formatMessage(translations.properties.shippingMethod),
                valueOnly: true,
                requestOptions: {
                  params: {},
                  headers: {
                    'x-page-size': 250,
                  },
                },
              },
            },
          },
        },
        credentials: {},
      };
    default:
      return {
        configuration: {},
        credentials: {},
      };
  }
};

export default getUISchema;
